import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setOrientation } from '@reducers/actions';
import AbstractGenerator from '@scene/misc/generator';
import { setOrientationActiveBtn } from '@reducers/selectors/dimension/actions';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { setAxisOrientation, setPerspectiveCamera } from '@reducers/camera/actions';
import Axis from '@scene/axis';
import Panel from '@scene/objects/panel';
import { CameraOrientations } from '@reducers/camera/defaults/generalCalculation';
import { APP_TEXTS } from '@texts';

// eslint-disable-next-line react/prefer-stateless-function
class ObjectOrientation extends Component {

  render () {
    return (
    <div className={`base-plate${this.props.panelType !== Panel.types.CUSTOM && "__btn-list" } list-type`}>
    <h4>{APP_TEXTS.BASE_PLATE_ORIENTATION.Content}</h4>
    <Tooltip content={APP_TOOLTIPS.TOOLTIP_SELECT_VIEW_ROTATION.Content}>
      <ul className="inline-list">
        <li>
          <button
            className={`btn btn-light ${this.props.activeBtn === '1' ? 'ImageButton--active' : ''}`}
            onClick={() => {
              this.props.setOrientation(AbstractGenerator.orientation.X);
              this.props.setAxisOrientation(Axis.types.Z_TOP);
              this.props.setActiveBtn('1');
              this.props.setPerspectiveCamera(CameraOrientations.Z_TOP.perspectiveCamera);
            }}
          >
            <span className="icon_dimensions-baseplate-position-1" />
          </button>
        </li>
        <li>
          <button
            className={`btn btn-light ${this.props.activeBtn === '2' ? 'ImageButton--active' : ''}`}
            onClick={() => {
              this.props.setOrientation(AbstractGenerator.orientation.Y_INVERT);
              this.props.setAxisOrientation(Axis.types.Y_TOP);
              this.props.setActiveBtn('2');
              this.props.setPerspectiveCamera(CameraOrientations.Y_TOP.perspectiveCamera);
            }}
          >
            <span className="icon_dimensions-baseplate-position-2" />
          </button>
        </li>
        <li>
          <button
            className={`btn btn-light ${this.props.activeBtn === '3' ? 'ImageButton--active' : ''}`}
            onClick={() => {
              this.props.setOrientation(AbstractGenerator.orientation.X_INVERT);
              this.props.setAxisOrientation(Axis.types.Z_BOTTOM);
              this.props.setActiveBtn('3');
              this.props.setPerspectiveCamera(CameraOrientations.Z_BOTTOM.perspectiveCamera);
            }}
          >
            <span className="icon_dimensions-baseplate-position-3" />
          </button>
        </li>
      </ul>
      </Tooltip>
    </div>
  );}  

}

const mapState = state => ({
  // VladP: Prevent error while switching from a design standard with Rebar application active to 
  // a design standard that do not have Rebar application (Ramset ANZ -> AS5216)
  activeBtn: state.selectors.dimension[state.main.appType].basePlate && 
    state.selectors.dimension[state.main.appType].basePlate.orientationActiveBtn,
  panelType: state.options.panel.type
});

const mapDispatch = dispatch => ({
  setOrientation: (orientation) => dispatch(setOrientation(orientation)),
  setAxisOrientation: (orientation) => dispatch(setAxisOrientation({ 
    orientation3D: orientation
  })),
  setActiveBtn: id => dispatch(setOrientationActiveBtn(id)),
  setPerspectiveCamera: (options) => dispatch(setPerspectiveCamera(options))
});

export default connect(mapState, mapDispatch)(ObjectOrientation);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/ObjectOrientation.js